import api from "@/api";

export default {
    state: {
        calls: [],
    },
    getters: {
        calls: (state) => state.calls,
    },
    mutations: {
        setCalls: (state, data) => {
            state.calls = data;
        },
    },
    actions: {
        getCalls: async ({ commit }, id) => {
            const response = await api({ requiresAuth: true }).get(
                `v1/customer-calls/${id}`
            );
            const { data } = response.data;
            commit("setCalls", data);
            return data;
        },

        createCalls: async (
            { dispatch },
            {
                agent_id,
                customer_id,
                call_category_id,
                date,
                time,
                description,
                duration_minutes,
            }
        ) => {
            const response = await api({ requiresAuth: true }).post("v1/calls", {
                agent_id,
                customer_id,
                call_category_id,
                date,
                time,
                description,
                duration_minutes,
            });

            const newCall = response.data.data;
            const callId = newCall.id;

            await dispatch("getCalls", customer_id);

            return callId;
        },

        deleteCalls: async ({ dispatch }, { callId, customerId }) => {
            await api({ requiresAuth: true }).delete(
                `v1/calls/${callId}`
            );
            await dispatch("getCalls", customerId);
        },

        updateCalls: async (
            { dispatch },
            {
                id,
                agent_id,
                customer_id,
                call_category_id,
                date,
                time,
                description,
                duration_minutes
            }
        ) => {
            try {
                await api({ requiresAuth: true }).patch(
                    `v1/calls/${id}`, {
                    agent_id,
                    customer_id,
                    call_category_id,
                    date,
                    time,
                    description,
                    duration_minutes
                }
                );
                await dispatch("getCalls", customer_id);
            } catch (err) {
                return err;
            }
        },

        addCallsFile: async (_, { callId, files }) => {
            const formData = new FormData();

            files.forEach((file) => {
                formData.append("call_files[]", file);
            });
            await api({ requiresAuth: true }).post(
                `v1/calls/${callId}/files`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
        },

        fetchCallsFiles: async ({ commit }, callId) => {
            const response = await api({ requiresAuth: true }).get(
                `/v1/calls/${callId}`
            );
            const { data } = response.data;
            commit("setFilesToEdit", data.files, { root: true });
            return data;
        },
    }
}
